import { useCallback } from "react";

import { NewMetadataInputMicro } from "../../../../../lib/domain-admin/metadata";
import { MetadataFieldView } from "../../shared/MetadataFieldView";
import { useMetadataInputs } from "../../shared/useMetadataInputs";
import { InfostatDataWarning } from "./InfostatDataWarning";
import { microEntries } from "./shared";
import { StepFooter } from "./StepFooter";
import { CompleteData1, CompleteData2 } from "./types";

export function Step2MetaMicro(props: {
  data: CompleteData1;
  handlePrevious: (data: CompleteData1) => void;
  handleNext: (data: CompleteData2) => void;
}) {
  const step3Data = props.data.step2;

  const {
    applicableEntries,
    textInputs,
    selectInputs,
    updateInput,
    multiselectInputs,
    updateMultiselect,
    collectData,
    breakdownParents,
    setBreakdownParents,
    breakdowns,
    setBreakdowns,
    useNoBreakdowns,
    setUseNoBreakdowns,
    updateSelect,
    allValid,
  } = useMetadataInputs<keyof NewMetadataInputMicro>(microEntries, step3Data);

  const handlePrevious = useCallback(() => {
    props.handlePrevious({
      ...props.data,
      step2: { ...props.data.step2, ...collectData() },
    });
  }, [collectData, props]);

  return (
    <div>
      <InfostatDataWarning></InfostatDataWarning>
      <h2>Mikro</h2>
      <section>
        {applicableEntries.map((field) => {
          return (
            <MetadataFieldView<keyof NewMetadataInputMicro>
              key={field.key}
              field={field}
              breakdownParents={breakdownParents}
              updateBreakdownParents={setBreakdownParents}
              breakdowns={breakdowns}
              useNoBreakdowns={useNoBreakdowns}
              setUseNoBreakdowns={setUseNoBreakdowns}
              updateBreakdowns={setBreakdowns}
              textInputs={textInputs}
              selectInputs={selectInputs}
              multiselectInputs={multiselectInputs}
              updateInput={updateInput}
              updateSelect={updateSelect}
              updateMultiselect={updateMultiselect}
            ></MetadataFieldView>
          );
        })}
      </section>

      <StepFooter
        handlePrevious={handlePrevious}
        handleNext={
          allValid
            ? () => {
                props.handleNext({
                  ...props.data,
                  step2: collectData(),
                });
              }
            : undefined
        }
      ></StepFooter>
    </div>
  );
}
